module.exports = __webpack_public_path__ + "static/img/5.178abe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/5.png
// module id = COF3
// module chunks = 0